import * as React from "react";
import { ArticleGW } from "./ArticleGW"
import { SelectionSetGW } from "./SelectionSetGW"
import { BuildPartSet } from "./BuildPartSet"
import { BDKalkCore } from "./BDKalkCore"
import { MakeNational } from "./BDKalkCore"
import { Assert } from "./PADebug"

// ExtTabGW is a toggle button that either shows or hides the extended info window below a selected item
export class BuildPartGW {

    constructor(sset: SelectionSetGW, core: BDKalkCore) {
        this.m_articles = new Array<ArticleGW>()
        this.m_meta = ""
        this.m_amount = 0
        this.m_title = "untitled build part"
        this.m_selectionSetId = "(no id)"
        this.m_set = sset
        this.m_expandedState = 0
    }

    // Access Articles
    public GetArticles() {
        return this.m_articles
    }

    // Access Title
    public GetTitle() {
        return this.m_title
    }

    // Access Title
    public SetTitle(newTitle:string) {
        this.m_title = newTitle
    }

    // Access Id
    public SetId(newId: string) {
        this.m_selectionSetId = newId
    }

    // Access Id
    public GetId() {
        return this.m_selectionSetId
    }

    // Access Amount
    public SetAmount(newAmount: number) {
        this.m_amount = newAmount
    }

    // Access Amount
    public GetAmount() {
        return this.m_amount
    }

    // Access Amount
    public AddAmount(amount: number) {
        this.m_amount += amount
        if (this.m_amount <= 0) {
            this.m_amount = 0
        }
    }

    // Access Meta
    public SetMeta(newMeta: string) {
        this.m_meta = newMeta
    }

    // Access Meta
    public GetMeta() {
        return this.m_meta
    }

    // Returns the price value of one such build part
    public GetPrice(radioPos: number, flags: number) {
        var sum = 0

        for (var i = 0; i < this.m_articles.length; i++) {
            sum += this.m_articles[i].GetSum(radioPos, flags)
        }
        
        if (this.m_includedBuildParts != null) {
            for (var i = 0; i < this.m_includedBuildParts.length; i++) {
                sum += (this.m_includedBuildParts[i].ref.GetPrice(radioPos, flags) * this.m_includedBuildParts[i].amount)
            }
        }

        return sum
    }


    // Returns the price value of one such build part as a string with two decimals
    public GetPriceString(radioPos: number, flags: number) {
        var result = this.GetPrice(radioPos, flags).toString()
        var decimalsShown = 0
        var passedComma = false

        // Counting the decimals of the total sum string
        for (var i = 0; i < result.length; i++) {
            if (passedComma == true) {
                decimalsShown++
            }

            // Ensuring there is no more than two decimals shown
            if (decimalsShown > 2) {
                result = result.slice(0, i)
                break
            }

            if (result[i] == '.') {
                passedComma = true
            }
        }

        // Ensuring there is allways two decimals shown on the total sum 
        if (decimalsShown == 0) {
            result += ".00"
        }

        if (decimalsShown == 1) {
            result += "0"
        }

        return MakeNational(result)
    }

    // Returns the total price for all of the articles within this build Par
    public GetTotalSum(radioPos: number, flags: number) {
        return (this.GetPrice(radioPos, flags) * this.m_amount)
    }

    // Returns the total price for all of the articles within this build Par
    public GetTotalSumString(radioPos: number, flags: number) {
        var sum = this.GetTotalSum(radioPos, flags)
        
        var result = sum.toString()
        var decimalsShown = 0
        var passedComma = false

        // Counting the decimals of the total sum string
        for (var i = 0; i < result.length; i++) {
            if (passedComma == true) {
                decimalsShown++
            }

            // Ensuring there is no more than two decimals shown
            if (decimalsShown > 2) {
                result = result.slice(0, i)
                break
            }

            if (result[i] == '.') {
                passedComma = true
            }
        }

        // Ensuring there is allways two decimals shown on the total sum 
        if (decimalsShown == 0) {
            result += ".00"
        }

        if (decimalsShown == 1) {
            result += "0"
        }

        return MakeNational(result)
    }

    // Access Articles
    public SetArticles(arts: Array<ArticleGW>) {
        this.m_articles = arts
    }

    // Access Set
    public SetSet(set: SelectionSetGW) {
        this.m_set = set
    }

    // Access Set
    public GetSet() {
        return this.m_set
    }

    // Access expanded state
    public IsExtended() {
        if (this.m_expandedState > 0) {
            return true
        }
        else {
            return false
        }
    }

    // GetIncludedBuildParts
    public GetIncludedBuildParts() {
        if (this.m_includedBuildParts == null) {
            this.ResetIncludedBuildPartsArray()
        }
        
        return this.m_includedBuildParts
    }

    // Ensures the included build parts array is not null
    public ResetIncludedBuildPartsArray() {
        this.m_includedBuildParts = new Array<{ ref: BuildPartGW, amount: number }>()
    }

    // Adds an owned build part to this build part, and sets an amount of it
    public InsertBuildPartReferencedAmount(BPRef: BuildPartGW, BPAmount: number) {
        this.m_includedBuildParts.push({ ref: BPRef, amount: BPAmount})
    }
    
    private m_meta: string // Meta is used to pass on various properties to a saved project or build part
    private m_title: string
    private m_selectionSetId: string // An ID recognised by the back end for this saved build part
    private m_articles: Array<ArticleGW> // Articles owned by this build part
    private m_amount: number // Chosen amount of this build part
    private m_set: SelectionSetGW
    private m_expandedState: number // Keeps track of if this build part was yet fully expanded with children and child data
    private m_includedBuildParts: Array<{ ref: BuildPartGW, amount: number }>
}



// WEBPACK FOOTER //
// ./client/view/BuildPartGW.tsx